import React, { useEffect } from "react";
import { Box, Container, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { AppBreadcrumbs } from "../components/common";

const PrivacyPage: React.FC = () => {
  useEffect(() => {
    console.debug("[DEBUG] Privacy page viewed");
  }, []);

  return (
    <>
      <AppBreadcrumbs />
      <Container maxWidth="md" sx={{ py: 6 }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Privacy Policy
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Last updated: {new Date().toLocaleDateString()}
        </Typography>

        <Box sx={{ display: "grid", gap: 3 }}>
          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              What We Collect
            </Typography>
            <Typography variant="body1">
              We collect account details you provide (name, email), settings,
              and financial data you connect or upload (accounts, transactions,
              categories, debts, goals, and related metadata).
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              How We Use Data
            </Typography>
            <Typography variant="body1">
              We use your data to deliver features such as dashboards, expense
              tracking, AI categorization, transaction search, sharing, and
              reporting. We also use it to secure the platform and improve the
              product.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Financial Connections
            </Typography>
            <Typography variant="body1">
              When you connect a financial institution, we use third-party
              providers (such as Plaid) to retrieve data. These providers may
              collect and process information under their own policies.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              AI Features
            </Typography>
            <Typography variant="body1">
              If you enable AI categorization, we send transaction details and
              learned patterns to our AI provider to suggest categories. We do
              not sell your data to third parties.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Payments and Connected Services
            </Typography>
            <Typography variant="body1">
              If you connect external services (such as Stripe), we receive
              related account and transaction data needed to display insights.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Sharing and Collaboration
            </Typography>
            <Typography variant="body1">
              If you share debts or invite group members, limited data is shared
              with those recipients. You control what you share and can revoke
              access.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Data Retention
            </Typography>
            <Typography variant="body1">
              We retain your data while your account is active. You can request
              deletion or export of your data at any time.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Cookies and Local Storage
            </Typography>
            <Typography variant="body1">
              We use browser storage and cookies to keep you signed in and save
              preferences. You can clear these in your browser settings.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Security
            </Typography>
            <Typography variant="body1">
              We use industry-standard safeguards, including encrypted
              transport. No system is perfectly secure, so please use strong
              passwords and enable any available security features.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Your Choices
            </Typography>
            <Typography variant="body1">
              You can update account settings, disconnect institutions, or
              delete your account. For privacy questions, contact us below.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Contact
            </Typography>
            <Typography variant="body1">
              Email{" "}
              <Link href="mailto:support@financetracker.app">
                support@financetracker.app
              </Link>{" "}
              or review our{" "}
              <Link component={RouterLink} to="/terms">
                Terms of Service
              </Link>
              .
            </Typography>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default PrivacyPage;
